import React from 'react';
import allModals from "./ModalLoader";

const PopupTenantInfo = React.lazy(() => import('@/modules/ModuleCore/Tenant/components/PopupTenantInfo'));
const PopupUserInfo = React.lazy(() => import('@/modules/ModuleCore/User/components/PoupInfo/PopupUserInfo'));

const modalRegistry = {
    modalUserInfo: PopupUserInfo,
    modalTenantInfo: PopupTenantInfo,
    ...allModals
};
console.log("modalRegistry", modalRegistry);
export default modalRegistry;
